import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';

export default class HomeDiscover extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    return (
      <section className="home-discover">

        {/* BEGIN: DISCOVER ITEM */}
        <div className="home-discoverItemWrapper">
          <div className="home-discoverItemIcon">
            <img src="images/home/discover/search.png" />
          </div>
          <div className="home-discoverItemCopy">
            <div className="home-discoverItemHeader">
              <h3 className="section-title">Discover</h3>
            </div>
            <div className="home-discoverItemCopy">
              Search across 10 categories &amp; 23 cities to find trusted resources
            </div>
          </div>
        </div>
        {/* END: DISCOVER ITEM */}

        {/* BEGIN: CONNECT ITEM */}
        <div className="home-discoverItemWrapper">
          <div className="home-discoverItemIcon">
            <img src="images/home/discover/connect.png" />
          </div>
          <div className="home-discoverItemCopy">
            <div className="home-discoverItemHeader">
              <h3 className="section-title">Connect</h3>
            </div>
            <div className="home-discoverItemCopy">
              Network and collaborate with women around the world
            </div>
          </div>
        </div>
        {/* END: CONNECT ITEM */}

        {/* BEGIN: INVEST ITEM */}
        <div className="home-discoverItemWrapper">
          <div className="home-discoverItemIcon">
            <img src="images/home/discover/invest.png" />
          </div>
          <div className="home-discoverItemCopy">
            <div className="home-discoverItemHeader">
              <h3 className="section-title">Invest</h3>
            </div>
            <div className="home-discoverItemCopy">
              Buy from women-owned businesses to help them grow
            </div>
          </div>
        </div>
        {/* END: INVEST ITEM */}




      </section>
    );
  }

};



// WEBPACK FOOTER //
// ./src/components/home/HomeDiscover.jsx